/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { fieldList as f } from "./fieldList.mjs";
const o = {};
o.undefined = (t) => t;
const i = (t, e) => e && e.arrays && !isNaN(Number(t)) ? [] : {};
function h(t) {
  if (o[t])
    return o[t];
  const e = f(t);
  return o[t] = (u, a, c) => {
    let r = u;
    const s = e.length - 1;
    for (let n = 0; n < s && r; n++)
      r = r[e[n]] = r[e[n]] || i(e[n + 1], c);
    r[e[s]] = a;
  }, o[t];
}
export {
  h as setter
};
